module.exports = __webpack_public_path__ + "static/media/p208kendi.f1771266.jpg";